var wenJson ={
	"type": "FeatureCollection",
	"features": [{
		"type": "Feature",
		"properties": {
			"adcode": 532601,
			"name": "文山市",
			"center": [104.244277, 23.369216],
			"centroid": [104.083844, 23.394664],
			"childrenNum": 0,
			"level": "district",
			"parent": {
				"adcode": 532600
			},
			"subFeatureIndex": 0,
			"acroutes": [100000, 530000, 532600]
		},
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				[
					[
						[103.747992, 23.538197],
						[103.74828, 23.535519],
						[103.738759, 23.534502],
						[103.735428, 23.528236],
						[103.71998, 23.521558],
						[103.721685, 23.516613],
						[103.734956, 23.510649],
						[103.735927, 23.505596],
						[103.731861, 23.494221],
						[103.735769, 23.492989],
						[103.744792, 23.495418],
						[103.754995, 23.494614],
						[103.767847, 23.500739],
						[103.770627, 23.499721],
						[103.776738, 23.491971],
						[103.786075, 23.491864],
						[103.793052, 23.490114],
						[103.798219, 23.492917],
						[103.800317, 23.491292],
						[103.790377, 23.478505],
						[103.788567, 23.473594],
						[103.793314, 23.469414],
						[103.806743, 23.470736],
						[103.809576, 23.46411],
						[103.808081, 23.4545],
						[103.798901, 23.445836],
						[103.809628, 23.439922],
						[103.816028, 23.434402],
						[103.81949, 23.428506],
						[103.819831, 23.422414],
						[103.817444, 23.415624],
						[103.807163, 23.410352],
						[103.803517, 23.405528],
						[103.811438, 23.395288],
						[103.8133, 23.391017],
						[103.815766, 23.370928],
						[103.808317, 23.358057],
						[103.811123, 23.34549],
						[103.815661, 23.338392],
						[103.820093, 23.342004],
						[103.825103, 23.349494],
						[103.83027, 23.3513],
						[103.837903, 23.345168],
						[103.839948, 23.341288],
						[103.85621, 23.332277],
						[103.863475, 23.332277],
						[103.86838, 23.329435],
						[103.878268, 23.329256],
						[103.882832, 23.32711],
						[103.890805, 23.318778],
						[103.897336, 23.31386],
						[103.905808, 23.311983],
						[103.906254, 23.309193],
						[103.913493, 23.30449],
						[103.912286, 23.301861],
						[103.917952, 23.293187],
						[103.922279, 23.281418],
						[103.925794, 23.278306],
						[103.925322, 23.271509],
						[103.932089, 23.267216],
						[103.936679, 23.258593],
						[103.936705, 23.253083],
						[103.931249, 23.243565],
						[103.920837, 23.238072],
						[103.912601, 23.232096],
						[103.913099, 23.220787],
						[103.91108, 23.216976],
						[103.908745, 23.199473],
						[103.914122, 23.191885],
						[103.915119, 23.183955],
						[103.921099, 23.17846],
						[103.928994, 23.167666],
						[103.928548, 23.16362],
						[103.931171, 23.156101],
						[103.938121, 23.152484],
						[103.938751, 23.146272],
						[103.942737, 23.144786],
						[103.940167, 23.139002],
						[103.940456, 23.129458],
						[103.936049, 23.121525],
						[103.937885, 23.116708],
						[103.937597, 23.099748],
						[103.945963, 23.09047],
						[103.949373, 23.092386],
						[103.980191, 23.097276],
						[103.994355, 23.102452],
						[104.013187, 23.119573],
						[104.037291, 23.138823],
						[104.052293, 23.14876],
						[104.058247, 23.150497],
						[104.066247, 23.149727],
						[104.074325, 23.144607],
						[104.108238, 23.129387],
						[104.124736, 23.125984],
						[104.133732, 23.122457],
						[104.143201, 23.121239],
						[104.151751, 23.127811],
						[104.162112, 23.132108],
						[104.177875, 23.13671],
						[104.194451, 23.139271],
						[104.217585, 23.13757],
						[104.229623, 23.133165],
						[104.24077, 23.134956],
						[104.254016, 23.143676],
						[104.260704, 23.145394],
						[104.262802, 23.139915],
						[104.263038, 23.128438],
						[104.266894, 23.121848],
						[104.271667, 23.119627],
						[104.289503, 23.124086],
						[104.300151, 23.128187],
						[104.316439, 23.136746],
						[104.324282, 23.142637],
						[104.34335, 23.162277],
						[104.376266, 23.174791],
						[104.386312, 23.182541],
						[104.390902, 23.189522],
						[104.399295, 23.207115],
						[104.408291, 23.21805],
						[104.421143, 23.235693],
						[104.424684, 23.237894],
						[104.417287, 23.243261],
						[104.407032, 23.246142],
						[104.389853, 23.257019],
						[104.386049, 23.260633],
						[104.373984, 23.265481],
						[104.373696, 23.26777],
						[104.38361, 23.270919],
						[104.399085, 23.269577],
						[104.405537, 23.271062],
						[104.41532, 23.279701],
						[104.421117, 23.289896],
						[104.427018, 23.305831],
						[104.430139, 23.31116],
						[104.421982, 23.335371],
						[104.416605, 23.342182],
						[104.405485, 23.351425],
						[104.387649, 23.358022],
						[104.371362, 23.374967],
						[104.371991, 23.38049],
						[104.379204, 23.394609],
						[104.381014, 23.403598],
						[104.379886, 23.411157],
						[104.373145, 23.422985],
						[104.358247, 23.431669],
						[104.365067, 23.441209],
						[104.366903, 23.449266],
						[104.365303, 23.454303],
						[104.351113, 23.46461],
						[104.337632, 23.476755],
						[104.325042, 23.481345],
						[104.302355, 23.47863],
						[104.288978, 23.485971],
						[104.274448, 23.487774],
						[104.258553, 23.483827],
						[104.244862, 23.482452],
						[104.230909, 23.48222],
						[104.217401, 23.485453],
						[104.201297, 23.49415],
						[104.195212, 23.498882],
						[104.186268, 23.509988],
						[104.186032, 23.521237],
						[104.189861, 23.528414],
						[104.19474, 23.53377],
						[104.209218, 23.544088],
						[104.214568, 23.550604],
						[104.212759, 23.554013],
						[104.212627, 23.571451],
						[104.208378, 23.584925],
						[104.211578, 23.598754],
						[104.205965, 23.616561],
						[104.19613, 23.622841],
						[104.176354, 23.62805],
						[104.164472, 23.635435],
						[104.152958, 23.637772],
						[104.146007, 23.648921],
						[104.139739, 23.661887],
						[104.128749, 23.675031],
						[104.111019, 23.686889],
						[104.081958, 23.702669],
						[104.076187, 23.708375],
						[104.066352, 23.711619],
						[104.058037, 23.711298],
						[104.052188, 23.713759],
						[104.04773, 23.712778],
						[104.043874, 23.706057],
						[104.034038, 23.705219],
						[104.030917, 23.701885],
						[104.021842, 23.701956],
						[104.020583, 23.697445],
						[104.026353, 23.690456],
						[104.025462, 23.680541],
						[104.022183, 23.674389],
						[104.017488, 23.673747],
						[104.009069, 23.677028],
						[103.999286, 23.684108],
						[103.996348, 23.684357],
						[103.981057, 23.680167],
						[103.972559, 23.679293],
						[103.960258, 23.680648],
						[103.951944, 23.683697],
						[103.939459, 23.682521],
						[103.932797, 23.678704],
						[103.918529, 23.66788],
						[103.9003, 23.657197],
						[103.888156, 23.653754],
						[103.882124, 23.655252],
						[103.872262, 23.663689],
						[103.861665, 23.666649],
						[103.855135, 23.66442],
						[103.852276, 23.657179],
						[103.851148, 23.641393],
						[103.849889, 23.638521],
						[103.841181, 23.636292],
						[103.835175, 23.637273],
						[103.809576, 23.649206],
						[103.805904, 23.647904],
						[103.797432, 23.639395],
						[103.798193, 23.635917],
						[103.804435, 23.629905],
						[103.802625, 23.609246],
						[103.793, 23.60516],
						[103.785236, 23.59804],
						[103.786075, 23.588137],
						[103.782902, 23.582712],
						[103.782534, 23.577519],
						[103.778023, 23.568702],
						[103.768292, 23.558422],
						[103.754811, 23.548051],
						[103.746234, 23.542964],
						[103.747992, 23.538197]
					]
				]
			]
		}
	}, {
		"type": "Feature",
		"properties": {
			"adcode": 532622,
			"name": "砚山县",
			"center": [104.343989, 23.612301],
			"centroid": [104.245163, 23.681758],
			"childrenNum": 0,
			"level": "district",
			"parent": {
				"adcode": 532600
			},
			"subFeatureIndex": 1,
			"acroutes": [100000, 530000, 532600]
		},
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				[
					[
						[103.706682, 23.890063],
						[103.705974, 23.887802],
						[103.693043, 23.881553],
						[103.688427, 23.881482],
						[103.685568, 23.874057],
						[103.679981, 23.871974],
						[103.666185, 23.870353],
						[103.660756, 23.865991],
						[103.665477, 23.854469],
						[103.664979, 23.849981],
						[103.655117, 23.83527],
						[103.652442, 23.825064],
						[103.649321, 23.826115],
						[103.642816, 23.822908],
						[103.643209, 23.816816],
						[103.653674, 23.817707],
						[103.650134, 23.809726],
						[103.650265, 23.801727],
						[103.646304, 23.791732],
						[103.644652, 23.78309],
						[103.646016, 23.773219],
						[103.644521, 23.763774],
						[103.640114, 23.755915],
						[103.630751, 23.747841],
						[103.638698, 23.73802],
						[103.644914, 23.740319],
						[103.646016, 23.738305],
						[103.642291, 23.730944],
						[103.64675, 23.726612],
						[103.650658, 23.714365],
						[103.646724, 23.70948],
						[103.651471, 23.704684],
						[103.652599, 23.699335],
						[103.648875, 23.691347],
						[103.653124, 23.686337],
						[103.646698, 23.686212],
						[103.646776, 23.678116],
						[103.648848, 23.673925],
						[103.660625, 23.666952],
						[103.660074, 23.66203],
						[103.662592, 23.653059],
						[103.659969, 23.647868],
						[103.651209, 23.637451],
						[103.649294, 23.628871],
						[103.637439, 23.6169],
						[103.633295, 23.610976],
						[103.629754, 23.6002],
						[103.626344, 23.595792],
						[103.61803, 23.591153],
						[103.614227, 23.583997],
						[103.608168, 23.583765],
						[103.597939, 23.579732],
						[103.588969, 23.578946],
						[103.586871, 23.575252],
						[103.592169, 23.566204],
						[103.593061, 23.56126],
						[103.592012, 23.547123],
						[103.595631, 23.539965],
						[103.622358, 23.523022],
						[103.624613, 23.516595],
						[103.632639, 23.507435],
						[103.635944, 23.505774],
						[103.647589, 23.504685],
						[103.653596, 23.505917],
						[103.665241, 23.514077],
						[103.674264, 23.524004],
						[103.67985, 23.526361],
						[103.694564, 23.518291],
						[103.696637, 23.519523],
						[103.703351, 23.532877],
						[103.706656, 23.541964],
						[103.715023, 23.547283],
						[103.724858, 23.5503],
						[103.732019, 23.545588],
						[103.734222, 23.540429],
						[103.73792, 23.53859],
						[103.747992, 23.538197],
						[103.746234, 23.542964],
						[103.754811, 23.548051],
						[103.768292, 23.558422],
						[103.778023, 23.568702],
						[103.782534, 23.577519],
						[103.782902, 23.582712],
						[103.786075, 23.588137],
						[103.785236, 23.59804],
						[103.793, 23.60516],
						[103.802625, 23.609246],
						[103.804435, 23.629905],
						[103.798193, 23.635917],
						[103.797432, 23.639395],
						[103.805904, 23.647904],
						[103.809576, 23.649206],
						[103.835175, 23.637273],
						[103.841181, 23.636292],
						[103.849889, 23.638521],
						[103.851148, 23.641393],
						[103.852276, 23.657179],
						[103.855135, 23.66442],
						[103.861665, 23.666649],
						[103.872262, 23.663689],
						[103.882124, 23.655252],
						[103.888156, 23.653754],
						[103.9003, 23.657197],
						[103.918529, 23.66788],
						[103.932797, 23.678704],
						[103.939459, 23.682521],
						[103.951944, 23.683697],
						[103.960258, 23.680648],
						[103.972559, 23.679293],
						[103.981057, 23.680167],
						[103.996348, 23.684357],
						[103.999286, 23.684108],
						[104.009069, 23.677028],
						[104.017488, 23.673747],
						[104.022183, 23.674389],
						[104.025462, 23.680541],
						[104.026353, 23.690456],
						[104.020583, 23.697445],
						[104.021842, 23.701956],
						[104.030917, 23.701885],
						[104.034038, 23.705219],
						[104.043874, 23.706057],
						[104.04773, 23.712778],
						[104.052188, 23.713759],
						[104.058037, 23.711298],
						[104.066352, 23.711619],
						[104.076187, 23.708375],
						[104.081958, 23.702669],
						[104.111019, 23.686889],
						[104.128749, 23.675031],
						[104.139739, 23.661887],
						[104.146007, 23.648921],
						[104.152958, 23.637772],
						[104.164472, 23.635435],
						[104.176354, 23.62805],
						[104.19613, 23.622841],
						[104.205965, 23.616561],
						[104.211578, 23.598754],
						[104.208378, 23.584925],
						[104.212627, 23.571451],
						[104.212759, 23.554013],
						[104.214568, 23.550604],
						[104.209218, 23.544088],
						[104.19474, 23.53377],
						[104.189861, 23.528414],
						[104.186032, 23.521237],
						[104.186268, 23.509988],
						[104.195212, 23.498882],
						[104.201297, 23.49415],
						[104.217401, 23.485453],
						[104.230909, 23.48222],
						[104.244862, 23.482452],
						[104.258553, 23.483827],
						[104.274448, 23.487774],
						[104.288978, 23.485971],
						[104.302355, 23.47863],
						[104.325042, 23.481345],
						[104.337632, 23.476755],
						[104.351113, 23.46461],
						[104.365303, 23.454303],
						[104.366903, 23.449266],
						[104.365067, 23.441209],
						[104.358247, 23.431669],
						[104.373145, 23.422985],
						[104.379886, 23.411157],
						[104.381014, 23.403598],
						[104.379204, 23.394609],
						[104.371991, 23.38049],
						[104.371362, 23.374967],
						[104.387649, 23.358022],
						[104.405485, 23.351425],
						[104.416605, 23.342182],
						[104.421982, 23.335371],
						[104.430139, 23.31116],
						[104.431582, 23.315076],
						[104.444224, 23.329721],
						[104.447817, 23.337355],
						[104.445378, 23.348118],
						[104.447765, 23.352963],
						[104.455633, 23.358129],
						[104.468302, 23.358522],
						[104.483409, 23.373412],
						[104.493009, 23.378363],
						[104.509244, 23.373501],
						[104.524693, 23.385637],
						[104.526817, 23.391624],
						[104.537885, 23.412211],
						[104.54203, 23.415695],
						[104.54578, 23.414605],
						[104.559734, 23.414784],
						[104.568048, 23.421788],
						[104.575418, 23.441405],
						[104.578802, 23.446497],
						[104.583261, 23.44839],
						[104.597476, 23.448605],
						[104.610905, 23.451088],
						[104.619403, 23.450534],
						[104.642065, 23.45341],
						[104.650038, 23.455607],
						[104.659795, 23.455071],
						[104.676266, 23.456268],
						[104.682981, 23.458894],
						[104.683112, 23.465556],
						[104.671991, 23.486274],
						[104.668765, 23.498846],
						[104.67068, 23.503453],
						[104.680122, 23.507292],
						[104.693079, 23.509792],
						[104.70795, 23.518523],
						[104.723504, 23.528628],
						[104.732605, 23.536787],
						[104.73688, 23.550389],
						[104.733759, 23.557226],
						[104.729458, 23.560849],
						[104.722769, 23.571754],
						[104.723923, 23.576823],
						[104.716894, 23.578554],
						[104.707295, 23.584604],
						[104.698561, 23.597327],
						[104.691741, 23.602269],
						[104.688358, 23.609781],
						[104.682273, 23.62805],
						[104.68062, 23.636506],
						[104.684659, 23.648742],
						[104.693472, 23.660585],
						[104.695885, 23.665668],
						[104.69001, 23.672927],
						[104.685499, 23.673765],
						[104.671493, 23.672392],
						[104.6631, 23.679596],
						[104.659139, 23.691704],
						[104.658116, 23.706128],
						[104.661395, 23.719339],
						[104.671362, 23.727557],
						[104.674588, 23.736897],
						[104.676765, 23.747823],
						[104.693236, 23.752421],
						[104.695964, 23.757643],
						[104.694495, 23.761332],
						[104.688174, 23.763435],
						[104.689354, 23.767837],
						[104.693944, 23.771152],
						[104.696331, 23.776996],
						[104.695518, 23.780845],
						[104.688122, 23.784284],
						[104.681565, 23.784445],
						[104.672778, 23.780934],
						[104.665591, 23.7853],
						[104.656648, 23.781594],
						[104.653658, 23.790075],
						[104.64335, 23.79526],
						[104.631075, 23.803865],
						[104.632858, 23.808426],
						[104.629318, 23.81564],
						[104.618616, 23.813734],
						[104.615548, 23.819274],
						[104.621685, 23.829517],
						[104.621161, 23.837888],
						[104.609489, 23.835038],
						[104.596847, 23.845137],
						[104.589083, 23.872597],
						[104.584231, 23.87744],
						[104.571379, 23.880342],
						[104.556245, 23.878989],
						[104.544862, 23.873772],
						[104.538069, 23.874787],
						[104.531696, 23.880752],
						[104.528469, 23.892093],
						[104.532561, 23.904181],
						[104.550187, 23.909646],
						[104.554357, 23.91406],
						[104.557688, 23.923281],
						[104.55698, 23.934049],
						[104.558921, 23.937982],
						[104.557793, 23.94462],
						[104.554724, 23.949389],
						[104.544652, 23.953162],
						[104.534974, 23.950065],
						[104.523486, 23.950599],
						[104.519919, 23.954924],
						[104.518503, 23.963856],
						[104.514096, 23.972503],
						[104.508247, 23.97841],
						[104.501454, 23.981293],
						[104.483724, 23.982235],
						[104.475934, 23.983961],
						[104.464735, 23.983125],
						[104.458151, 23.974336],
						[104.455292, 23.967183],
						[104.444171, 23.961756],
						[104.437037, 23.955689],
						[104.429116, 23.938836],
						[104.416291, 23.929243],
						[104.411648, 23.92458],
						[104.400895, 23.910643],
						[104.396462, 23.906673],
						[104.387754, 23.904697],
						[104.375112, 23.898057],
						[104.371965, 23.892271],
						[104.365565, 23.886182],
						[104.347494, 23.875553],
						[104.340019, 23.873808],
						[104.328216, 23.87427],
						[104.312348, 23.879042],
						[104.296479, 23.882425],
						[104.27909, 23.887393],
						[104.264822, 23.885968],
						[104.259943, 23.890063],
						[104.245885, 23.889921],
						[104.237308, 23.887784],
						[104.212785, 23.873861],
						[104.201559, 23.876087],
						[104.194005, 23.873291],
						[104.192982, 23.86989],
						[104.187265, 23.865848],
						[104.16038, 23.865154],
						[104.153535, 23.860666],
						[104.153037, 23.857657],
						[104.158335, 23.855822],
						[104.159226, 23.850515],
						[104.166413, 23.846384],
						[104.168826, 23.84072],
						[104.169534, 23.829748],
						[104.173573, 23.824209],
						[104.172341, 23.821091],
						[104.158308, 23.818847],
						[104.15482, 23.817101],
						[104.156368, 23.808657],
						[104.147109, 23.805736],
						[104.141601, 23.802137],
						[104.129011, 23.790627],
						[104.127543, 23.785193],
						[104.121143, 23.783999],
						[104.121431, 23.775678],
						[104.116238, 23.772007],
						[104.115923, 23.767035],
						[104.126388, 23.758018],
						[104.127516, 23.752136],
						[104.124448, 23.749605],
						[104.112251, 23.746023],
						[104.106035, 23.746665],
						[104.095964, 23.753651],
						[104.089485, 23.752136],
						[104.079335, 23.755861],
						[104.071991, 23.760085],
						[104.069132, 23.764843],
						[104.064594, 23.777834],
						[104.060739, 23.781897],
						[104.049618, 23.786725],
						[104.043271, 23.790948],
						[104.024754, 23.789879],
						[104.010328, 23.784765],
						[103.994407, 23.789469],
						[103.975549, 23.792284],
						[103.971982, 23.79542],
						[103.969412, 23.809352],
						[103.963956, 23.828519],
						[103.960258, 23.837389],
						[103.95273, 23.848236],
						[103.948193, 23.850213],
						[103.935367, 23.85178],
						[103.921414, 23.848984],
						[103.913493, 23.845386],
						[103.907382, 23.839313],
						[103.89849, 23.834789],
						[103.879527, 23.834433],
						[103.864472, 23.836926],
						[103.86017, 23.839135],
						[103.857548, 23.844834],
						[103.872314, 23.867273],
						[103.87116, 23.874787],
						[103.867383, 23.880057],
						[103.858833, 23.879808],
						[103.851935, 23.881731],
						[103.84766, 23.880645],
						[103.841129, 23.884847],
						[103.834362, 23.882461],
						[103.830559, 23.883422],
						[103.827254, 23.88823],
						[103.825103, 23.896544],
						[103.818546, 23.901795],
						[103.81254, 23.9016],
						[103.796698, 23.896294],
						[103.789616, 23.891648],
						[103.778758, 23.881927],
						[103.772673, 23.868199],
						[103.770338, 23.86567],
						[103.759926, 23.863515],
						[103.753185, 23.866329],
						[103.734327, 23.881784],
						[103.727848, 23.886075],
						[103.714446, 23.889921],
						[103.706682, 23.890063]
					]
				]
			]
		}
	}, {
		"type": "Feature",
		"properties": {
			"adcode": 532623,
			"name": "西畴县",
			"center": [104.675711, 23.437439],
			"centroid": [104.680698, 23.35806],
			"childrenNum": 0,
			"level": "district",
			"parent": {
				"adcode": 532600
			},
			"subFeatureIndex": 2,
			"acroutes": [100000, 530000, 532600]
		},
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				[
					[
						[104.933593, 23.526504],
						[104.926774, 23.533788],
						[104.918118, 23.540732],
						[104.915181, 23.541482],
						[104.913764, 23.554548],
						[104.907601, 23.560046],
						[104.901673, 23.560635],
						[104.890841, 23.564776],
						[104.870907, 23.567524],
						[104.856429, 23.573503],
						[104.845702, 23.58405],
						[104.835709, 23.588066],
						[104.804287, 23.592669],
						[104.794635, 23.596827],
						[104.788629, 23.60127],
						[104.785114, 23.608157],
						[104.77861, 23.615954],
						[104.77596, 23.616793],
						[104.770059, 23.610976],
						[104.768748, 23.601092],
						[104.765049, 23.59829],
						[104.751044, 23.599022],
						[104.739346, 23.596559],
						[104.732474, 23.589814],
						[104.723923, 23.576823],
						[104.722769, 23.571754],
						[104.729458, 23.560849],
						[104.733759, 23.557226],
						[104.73688, 23.550389],
						[104.732605, 23.536787],
						[104.723504, 23.528628],
						[104.70795, 23.518523],
						[104.693079, 23.509792],
						[104.680122, 23.507292],
						[104.67068, 23.503453],
						[104.668765, 23.498846],
						[104.671991, 23.486274],
						[104.683112, 23.465556],
						[104.682981, 23.458894],
						[104.676266, 23.456268],
						[104.659795, 23.455071],
						[104.650038, 23.455607],
						[104.642065, 23.45341],
						[104.619403, 23.450534],
						[104.610905, 23.451088],
						[104.597476, 23.448605],
						[104.583261, 23.44839],
						[104.578802, 23.446497],
						[104.575418, 23.441405],
						[104.568048, 23.421788],
						[104.559734, 23.414784],
						[104.54578, 23.414605],
						[104.54203, 23.415695],
						[104.537885, 23.412211],
						[104.526817, 23.391624],
						[104.524693, 23.385637],
						[104.509244, 23.373501],
						[104.493009, 23.378363],
						[104.483409, 23.373412],
						[104.468302, 23.358522],
						[104.455633, 23.358129],
						[104.447765, 23.352963],
						[104.445378, 23.348118],
						[104.447817, 23.337355],
						[104.444224, 23.329721],
						[104.431582, 23.315076],
						[104.430139, 23.31116],
						[104.427018, 23.305831],
						[104.421117, 23.289896],
						[104.41532, 23.279701],
						[104.405537, 23.271062],
						[104.399085, 23.269577],
						[104.38361, 23.270919],
						[104.373696, 23.26777],
						[104.373984, 23.265481],
						[104.386049, 23.260633],
						[104.389853, 23.257019],
						[104.407032, 23.246142],
						[104.417287, 23.243261],
						[104.424684, 23.237894],
						[104.436696, 23.224187],
						[104.452643, 23.219517],
						[104.459909, 23.214757],
						[104.464289, 23.204234],
						[104.465259, 23.187267],
						[104.464131, 23.177834],
						[104.461063, 23.166108],
						[104.449784, 23.137767],
						[104.464735, 23.133308],
						[104.478872, 23.133201],
						[104.497441, 23.134257],
						[104.502346, 23.139575],
						[104.507146, 23.132037],
						[104.509559, 23.119215],
						[104.524509, 23.113126],
						[104.521257, 23.096345],
						[104.532273, 23.087478],
						[104.54182, 23.083018],
						[104.542134, 23.097419],
						[104.548324, 23.111962],
						[104.564481, 23.12482],
						[104.566999, 23.135869],
						[104.558396, 23.158733],
						[104.558291, 23.164927],
						[104.568835, 23.172875],
						[104.594985, 23.184958],
						[104.603168, 23.186229],
						[104.605502, 23.180751],
						[104.60385, 23.175435],
						[104.596296, 23.16729],
						[104.597345, 23.16294],
						[104.607338, 23.161024],
						[104.620059, 23.160756],
						[104.627508, 23.16294],
						[104.629895, 23.168722],
						[104.630839, 23.184815],
						[104.633488, 23.189916],
						[104.655625, 23.194856],
						[104.661552, 23.197934],
						[104.669893, 23.205415],
						[104.681381, 23.219392],
						[104.688148, 23.217888],
						[104.691951, 23.214274],
						[104.7058, 23.191992],
						[104.711491, 23.181521],
						[104.724553, 23.175274],
						[104.729536, 23.175578],
						[104.735674, 23.180733],
						[104.741523, 23.187929],
						[104.746978, 23.204538],
						[104.761587, 23.224492],
						[104.771213, 23.244603],
						[104.772131, 23.248754],
						[104.76484, 23.253477],
						[104.769692, 23.256572],
						[104.772, 23.269631],
						[104.770872, 23.282241],
						[104.765548, 23.291381],
						[104.76644, 23.300341],
						[104.772918, 23.321049],
						[104.778295, 23.328433],
						[104.788209, 23.33403],
						[104.792615, 23.340716],
						[104.798805, 23.343273],
						[104.813074, 23.334673],
						[104.820575, 23.331956],
						[104.830699, 23.335245],
						[104.839459, 23.354589],
						[104.852206, 23.356931],
						[104.856298, 23.362955],
						[104.86414, 23.363831],
						[104.873032, 23.371088],
						[104.882631, 23.372483],
						[104.894749, 23.371893],
						[104.905293, 23.375593],
						[104.911587, 23.375611],
						[104.921633, 23.367889],
						[104.932806, 23.372751],
						[104.940176, 23.373037],
						[104.949776, 23.37654],
						[104.95114, 23.380007],
						[104.945684, 23.390731],
						[104.944583, 23.396003],
						[104.946471, 23.402919],
						[104.952897, 23.407601],
						[104.965565, 23.41398],
						[104.981722, 23.419733],
						[104.979152, 23.424986],
						[104.954366, 23.426898],
						[104.94933, 23.428667],
						[104.940071, 23.445746],
						[104.913948, 23.454803],
						[104.908414, 23.458626],
						[104.907233, 23.468253],
						[104.912191, 23.47154],
						[104.922131, 23.473969],
						[104.928505, 23.482774],
						[104.932806, 23.494078],
						[104.932439, 23.504971],
						[104.929633, 23.505864],
						[104.930367, 23.515738],
						[104.929055, 23.520523],
						[104.933593, 23.526504]
					]
				]
			]
		}
	}, {
		"type": "Feature",
		"properties": {
			"adcode": 532624,
			"name": "麻栗坡县",
			"center": [104.701899, 23.124202],
			"centroid": [104.896605, 23.220433],
			"childrenNum": 0,
			"level": "district",
			"parent": {
				"adcode": 532600
			},
			"subFeatureIndex": 3,
			"acroutes": [100000, 530000, 532600]
		},
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				[
					[
						[105.236111, 23.49431],
						[105.230105, 23.497221],
						[105.227613, 23.501221],
						[105.21442, 23.508578],
						[105.193254, 23.513452],
						[105.174343, 23.52038],
						[105.163878, 23.530271],
						[105.153177, 23.533288],
						[105.12826, 23.530574],
						[105.116562, 23.534948],
						[105.09335, 23.539768],
						[105.077875, 23.548711],
						[105.074125, 23.547801],
						[105.066623, 23.540893],
						[105.063161, 23.533092],
						[105.06442, 23.511988],
						[105.059542, 23.505185],
						[105.042913, 23.512024],
						[105.028854, 23.516184],
						[105.008947, 23.524147],
						[104.999348, 23.528807],
						[104.985158, 23.539161],
						[104.978889, 23.540661],
						[104.971414, 23.538037],
						[104.961867, 23.524111],
						[104.956962, 23.527218],
						[104.9567, 23.533109],
						[104.941619, 23.53593],
						[104.933409, 23.529342],
						[104.933593, 23.526504],
						[104.929055, 23.520523],
						[104.930367, 23.515738],
						[104.929633, 23.505864],
						[104.932439, 23.504971],
						[104.932806, 23.494078],
						[104.928505, 23.482774],
						[104.922131, 23.473969],
						[104.912191, 23.47154],
						[104.907233, 23.468253],
						[104.908414, 23.458626],
						[104.913948, 23.454803],
						[104.940071, 23.445746],
						[104.94933, 23.428667],
						[104.954366, 23.426898],
						[104.979152, 23.424986],
						[104.981722, 23.419733],
						[104.965565, 23.41398],
						[104.952897, 23.407601],
						[104.946471, 23.402919],
						[104.944583, 23.396003],
						[104.945684, 23.390731],
						[104.95114, 23.380007],
						[104.949776, 23.37654],
						[104.940176, 23.373037],
						[104.932806, 23.372751],
						[104.921633, 23.367889],
						[104.911587, 23.375611],
						[104.905293, 23.375593],
						[104.894749, 23.371893],
						[104.882631, 23.372483],
						[104.873032, 23.371088],
						[104.86414, 23.363831],
						[104.856298, 23.362955],
						[104.852206, 23.356931],
						[104.839459, 23.354589],
						[104.830699, 23.335245],
						[104.820575, 23.331956],
						[104.813074, 23.334673],
						[104.798805, 23.343273],
						[104.792615, 23.340716],
						[104.788209, 23.33403],
						[104.778295, 23.328433],
						[104.772918, 23.321049],
						[104.76644, 23.300341],
						[104.765548, 23.291381],
						[104.770872, 23.282241],
						[104.772, 23.269631],
						[104.769692, 23.256572],
						[104.76484, 23.253477],
						[104.772131, 23.248754],
						[104.771213, 23.244603],
						[104.761587, 23.224492],
						[104.746978, 23.204538],
						[104.741523, 23.187929],
						[104.735674, 23.180733],
						[104.729536, 23.175578],
						[104.724553, 23.175274],
						[104.711491, 23.181521],
						[104.7058, 23.191992],
						[104.691951, 23.214274],
						[104.688148, 23.217888],
						[104.681381, 23.219392],
						[104.669893, 23.205415],
						[104.661552, 23.197934],
						[104.655625, 23.194856],
						[104.633488, 23.189916],
						[104.630839, 23.184815],
						[104.629895, 23.168722],
						[104.627508, 23.16294],
						[104.620059, 23.160756],
						[104.607338, 23.161024],
						[104.597345, 23.16294],
						[104.596296, 23.16729],
						[104.60385, 23.175435],
						[104.605502, 23.180751],
						[104.603168, 23.186229],
						[104.594985, 23.184958],
						[104.568835, 23.172875],
						[104.558291, 23.164927],
						[104.558396, 23.158733],
						[104.566999, 23.135869],
						[104.564481, 23.12482],
						[104.548324, 23.111962],
						[104.542134, 23.097419],
						[104.54182, 23.083018],
						[104.547747, 23.080492],
						[104.557924, 23.080797],
						[104.558239, 23.074366],
						[104.554855, 23.068149],
						[104.558422, 23.060607],
						[104.576231, 23.057651],
						[104.572769, 23.051201],
						[104.571432, 23.044446],
						[104.568101, 23.041454],
						[104.567287, 23.032154],
						[104.570855, 23.024287],
						[104.576441, 23.017817],
						[104.572166, 23.011992],
						[104.562121, 23.008784],
						[104.555196, 23.008838],
						[104.551367, 23.003264],
						[104.550213, 22.993782],
						[104.552416, 22.992366],
						[104.552705, 22.977434],
						[104.564088, 22.965547],
						[104.573399, 22.965117],
						[104.576782, 22.950236],
						[104.571379, 22.942095],
						[104.576389, 22.932268],
						[104.580952, 22.927731],
						[104.594434, 22.92357],
						[104.612086, 22.920575],
						[104.625147, 22.921723],
						[104.636504, 22.913293],
						[104.645868, 22.911751],
						[104.656726, 22.917741],
						[104.66226, 22.916594],
						[104.663336, 22.912074],
						[104.654235, 22.898083],
						[104.64933, 22.893527],
						[104.654261, 22.884378],
						[104.653789, 22.868214],
						[104.64217, 22.862527],
						[104.630314, 22.847149],
						[104.625278, 22.834624],
						[104.633331, 22.834552],
						[104.638891, 22.83238],
						[104.657749, 22.830837],
						[104.663782, 22.827032],
						[104.668188, 22.821181],
						[104.674168, 22.817179],
						[104.680515, 22.817233],
						[104.702941, 22.822384],
						[104.713799, 22.823174],
						[104.724395, 22.821128],
						[104.735726, 22.822348],
						[104.737693, 22.826027],
						[104.736565, 22.834372],
						[104.733654, 22.843291],
						[104.732789, 22.852102],
						[104.737142, 22.856175],
						[104.752617, 22.857718],
						[104.760932, 22.862509],
						[104.7656, 22.878351],
						[104.772682, 22.893455],
						[104.778583, 22.901204],
						[104.783724, 22.904164],
						[104.804313, 22.908254],
						[104.811421, 22.91306],
						[104.829597, 22.923014],
						[104.846226, 22.926368],
						[104.861622, 22.939997],
						[104.864639, 22.95063],
						[104.864062, 22.958806],
						[104.860363, 22.97098],
						[104.849243, 22.978007],
						[104.843, 22.984801],
						[104.837387, 22.994338],
						[104.829099, 23.017925],
						[104.827132, 23.02667],
						[104.820759, 23.032171],
						[104.820339, 23.037691],
						[104.823067, 23.045413],
						[104.817087, 23.052742],
						[104.816982, 23.072968],
						[104.815382, 23.076641],
						[104.807828, 23.080653],
						[104.804969, 23.098655],
						[104.804523, 23.110046],
						[104.809139, 23.116457],
						[104.820365, 23.115974],
						[104.823145, 23.109509],
						[104.826162, 23.107933],
						[104.832981, 23.115598],
						[104.856429, 23.123406],
						[104.86915, 23.122331],
						[104.874317, 23.123441],
						[104.877517, 23.128509],
						[104.882185, 23.147632],
						[104.882658, 23.163477],
						[104.886566, 23.168812],
						[104.893254, 23.171425],
						[104.912584, 23.175811],
						[104.920453, 23.164032],
						[104.928846, 23.160022],
						[104.938393, 23.159699],
						[104.941409, 23.151929],
						[104.948858, 23.152198],
						[104.953553, 23.160881],
						[104.955467, 23.177064],
						[104.958798, 23.188627],
						[104.964175, 23.195124],
						[104.973749, 23.197379],
						[104.997302, 23.196055],
						[104.999715, 23.197469],
						[105.000843, 23.207831],
						[105.003623, 23.213003],
						[105.023556, 23.217638],
						[105.03612, 23.224581],
						[105.055214, 23.245247],
						[105.064997, 23.24768],
						[105.081862, 23.260418],
						[105.093166, 23.26108],
						[105.099907, 23.256375],
						[105.108222, 23.245855],
						[105.122096, 23.247662],
						[105.146305, 23.259846],
						[105.182028, 23.278932],
						[105.191182, 23.277823],
						[105.208283, 23.269005],
						[105.215837, 23.266804],
						[105.232544, 23.264246],
						[105.238104, 23.264246],
						[105.242275, 23.273816],
						[105.244242, 23.289252],
						[105.250983, 23.297712],
						[105.256543, 23.30837],
						[105.26011, 23.317937],
						[105.257671, 23.333726],
						[105.261264, 23.338142],
						[105.27944, 23.339465],
						[105.283899, 23.342719],
						[105.295912, 23.356234],
						[105.303885, 23.36653],
						[105.311124, 23.379578],
						[105.290115, 23.381562],
						[105.276136, 23.386299],
						[105.27068, 23.396753],
						[105.268949, 23.409084],
						[105.274562, 23.415999],
						[105.274352, 23.42429],
						[105.278995, 23.42697],
						[105.29182, 23.428756],
						[105.284843, 23.437707],
						[105.281722, 23.433759],
						[105.258982, 23.435796],
						[105.252714, 23.438118],
						[105.240308, 23.447265],
						[105.237055, 23.455536],
						[105.239836, 23.466557],
						[105.244347, 23.470379],
						[105.254287, 23.473987],
						[105.250406, 23.47972],
						[105.239809, 23.483292],
						[105.2364, 23.486738],
						[105.236111, 23.49431]
					]
				]
			]
		}
	}, {
		"type": "Feature",
		"properties": {
			"adcode": 532625,
			"name": "马关县",
			"center": [104.398619, 23.011723],
			"centroid": [104.263043, 22.950345],
			"childrenNum": 0,
			"level": "district",
			"parent": {
				"adcode": 532600
			},
			"subFeatureIndex": 4,
			"acroutes": [100000, 530000, 532600]
		},
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				[
					[
						[103.945963, 23.09047],
						[103.9462, 23.087944],
						[103.939039, 23.07596],
						[103.943157, 23.069135],
						[103.942055, 23.064871],
						[103.933295, 23.055304],
						[103.934554, 23.041579],
						[103.938803, 23.037888],
						[103.943105, 23.027082],
						[103.958029, 23.00597],
						[103.95635, 22.994571],
						[103.952914, 22.988906],
						[103.950685, 22.979262],
						[103.951393, 22.975479],
						[103.947904, 22.953373],
						[103.937072, 22.952011],
						[103.930908, 22.946058],
						[103.924194, 22.932824],
						[103.917217, 22.929937],
						[103.907644, 22.916038],
						[103.913126, 22.905473],
						[103.917637, 22.893258],
						[103.913099, 22.885006],
						[103.918738, 22.869954],
						[103.916378, 22.866904],
						[103.918948, 22.853071],
						[103.916404, 22.842017],
						[103.91706, 22.837477],
						[103.910791, 22.822761],
						[103.907067, 22.818364],
						[103.898018, 22.817215],
						[103.886609, 22.819189],
						[103.883068, 22.815546],
						[103.886661, 22.81113],
						[103.895133, 22.806158],
						[103.897205, 22.799894],
						[103.891015, 22.782283],
						[103.894556, 22.766089],
						[103.898044, 22.761492],
						[103.901008, 22.751114],
						[103.904444, 22.745296],
						[103.905572, 22.738759],
						[103.889048, 22.722865],
						[103.890386, 22.71277],
						[103.896864, 22.699173],
						[103.903919, 22.692544],
						[103.912627, 22.689059],
						[103.92346, 22.68816],
						[103.928312, 22.691933],
						[103.927184, 22.699209],
						[103.934816, 22.707328],
						[103.943918, 22.709214],
						[103.954514, 22.707723],
						[103.963405, 22.699891],
						[103.982552, 22.704346],
						[103.989896, 22.709106],
						[104.001909, 22.726618],
						[104.000702, 22.737609],
						[104.001515, 22.749031],
						[104.00663, 22.751796],
						[104.011666, 22.751365],
						[104.013528, 22.746481],
						[104.017436, 22.753987],
						[104.022944, 22.758135],
						[104.027744, 22.765694],
						[104.03034, 22.773235],
						[104.02798, 22.782373],
						[104.03215, 22.789931],
						[104.039441, 22.796986],
						[104.038733, 22.800989],
						[104.035061, 22.798619],
						[104.031835, 22.803125],
						[104.037291, 22.809012],
						[104.03535, 22.812979],
						[104.027324, 22.810502],
						[104.022708, 22.821881],
						[104.028793, 22.82775],
						[104.031075, 22.836436],
						[104.03535, 22.839397],
						[104.043428, 22.839577],
						[104.048071, 22.82705],
						[104.059296, 22.825561],
						[104.061211, 22.823317],
						[104.067427, 22.823443],
						[104.073538, 22.827607],
						[104.065381, 22.830299],
						[104.066588, 22.832632],
						[104.07582, 22.836257],
						[104.080174, 22.836346],
						[104.084843, 22.847939],
						[104.091505, 22.855547],
						[104.09536, 22.867873],
						[104.100055, 22.875014],
						[104.105222, 22.875337],
						[104.110153, 22.879768],
						[104.115005, 22.880091],
						[104.118704, 22.894603],
						[104.132814, 22.895769],
						[104.137116, 22.898891],
						[104.139608, 22.895608],
						[104.13848, 22.888612],
						[104.139817, 22.884038],
						[104.145457, 22.881849],
						[104.147686, 22.869398],
						[104.157049, 22.861378],
						[104.170819, 22.865343],
						[104.179344, 22.872915],
						[104.179448, 22.855457],
						[104.177009, 22.854255],
						[104.175908, 22.847347],
						[104.182176, 22.843435],
						[104.190228, 22.844152],
						[104.198071, 22.852891],
						[104.204208, 22.855888],
						[104.218109, 22.871067],
						[104.227368, 22.872951],
						[104.232456, 22.866725],
						[104.240193, 22.864913],
						[104.257924, 22.872951],
						[104.261963, 22.871802],
						[104.269543, 22.866061],
						[104.276205, 22.863208],
						[104.282054, 22.845409],
						[104.280979, 22.835664],
						[104.272743, 22.825148],
						[104.268599, 22.816766],
						[104.269936, 22.810718],
						[104.264822, 22.798763],
						[104.262986, 22.790416],
						[104.25997, 22.784563],
						[104.258527, 22.776808],
						[104.259471, 22.763593],
						[104.270881, 22.750773],
						[104.271431, 22.739765],
						[104.273084, 22.738148],
						[104.281634, 22.738525],
						[104.290158, 22.734952],
						[104.299942, 22.72845],
						[104.310512, 22.726798],
						[104.322498, 22.728953],
						[104.340832, 22.71929],
						[104.343481, 22.71462],
						[104.34453, 22.704562],
						[104.36289, 22.69134],
						[104.369552, 22.688879],
						[104.376004, 22.690137],
						[104.385499, 22.699496],
						[104.39237, 22.703053],
						[104.402862, 22.702298],
						[104.40677, 22.708944],
						[104.411596, 22.722434],
						[104.422769, 22.735005],
						[104.456735, 22.74781],
						[104.46421, 22.752604],
						[104.478767, 22.764419],
						[104.501612, 22.776628],
						[104.50468, 22.786933],
						[104.513755, 22.789159],
						[104.521624, 22.795442],
						[104.525925, 22.802802],
						[104.52784, 22.8142],
						[104.534922, 22.819728],
						[104.54397, 22.824538],
						[104.559393, 22.828271],
						[104.566474, 22.833457],
						[104.57395, 22.84304],
						[104.579484, 22.846378],
						[104.595457, 22.84627],
						[104.601279, 22.842161],
						[104.600545, 22.838123],
						[104.607181, 22.825435],
						[104.600204, 22.820858],
						[104.599916, 22.813805],
						[104.610381, 22.814666],
						[104.614866, 22.813141],
						[104.621843, 22.819405],
						[104.625908, 22.826691],
						[104.620898, 22.830191],
						[104.620295, 22.834982],
						[104.625278, 22.834624],
						[104.630314, 22.847149],
						[104.64217, 22.862527],
						[104.653789, 22.868214],
						[104.654261, 22.884378],
						[104.64933, 22.893527],
						[104.654235, 22.898083],
						[104.663336, 22.912074],
						[104.66226, 22.916594],
						[104.656726, 22.917741],
						[104.645868, 22.911751],
						[104.636504, 22.913293],
						[104.625147, 22.921723],
						[104.612086, 22.920575],
						[104.594434, 22.92357],
						[104.580952, 22.927731],
						[104.576389, 22.932268],
						[104.571379, 22.942095],
						[104.576782, 22.950236],
						[104.573399, 22.965117],
						[104.564088, 22.965547],
						[104.552705, 22.977434],
						[104.552416, 22.992366],
						[104.550213, 22.993782],
						[104.551367, 23.003264],
						[104.555196, 23.008838],
						[104.562121, 23.008784],
						[104.572166, 23.011992],
						[104.576441, 23.017817],
						[104.570855, 23.024287],
						[104.567287, 23.032154],
						[104.568101, 23.041454],
						[104.571432, 23.044446],
						[104.572769, 23.051201],
						[104.576231, 23.057651],
						[104.558422, 23.060607],
						[104.554855, 23.068149],
						[104.558239, 23.074366],
						[104.557924, 23.080797],
						[104.547747, 23.080492],
						[104.54182, 23.083018],
						[104.532273, 23.087478],
						[104.521257, 23.096345],
						[104.524509, 23.113126],
						[104.509559, 23.119215],
						[104.507146, 23.132037],
						[104.502346, 23.139575],
						[104.497441, 23.134257],
						[104.478872, 23.133201],
						[104.464735, 23.133308],
						[104.449784, 23.137767],
						[104.461063, 23.166108],
						[104.464131, 23.177834],
						[104.465259, 23.187267],
						[104.464289, 23.204234],
						[104.459909, 23.214757],
						[104.452643, 23.219517],
						[104.436696, 23.224187],
						[104.424684, 23.237894],
						[104.421143, 23.235693],
						[104.408291, 23.21805],
						[104.399295, 23.207115],
						[104.390902, 23.189522],
						[104.386312, 23.182541],
						[104.376266, 23.174791],
						[104.34335, 23.162277],
						[104.324282, 23.142637],
						[104.316439, 23.136746],
						[104.300151, 23.128187],
						[104.289503, 23.124086],
						[104.271667, 23.119627],
						[104.266894, 23.121848],
						[104.263038, 23.128438],
						[104.262802, 23.139915],
						[104.260704, 23.145394],
						[104.254016, 23.143676],
						[104.24077, 23.134956],
						[104.229623, 23.133165],
						[104.217585, 23.13757],
						[104.194451, 23.139271],
						[104.177875, 23.13671],
						[104.162112, 23.132108],
						[104.151751, 23.127811],
						[104.143201, 23.121239],
						[104.133732, 23.122457],
						[104.124736, 23.125984],
						[104.108238, 23.129387],
						[104.074325, 23.144607],
						[104.066247, 23.149727],
						[104.058247, 23.150497],
						[104.052293, 23.14876],
						[104.037291, 23.138823],
						[104.013187, 23.119573],
						[103.994355, 23.102452],
						[103.980191, 23.097276],
						[103.949373, 23.092386],
						[103.945963, 23.09047]
					]
				]
			]
		}
	}, {
		"type": "Feature",
		"properties": {
			"adcode": 532626,
			"name": "丘北县",
			"center": [104.194366, 24.040982],
			"centroid": [104.103703, 24.121397],
			"childrenNum": 0,
			"level": "district",
			"parent": {
				"adcode": 532600
			},
			"subFeatureIndex": 5,
			"acroutes": [100000, 530000, 532600]
		},
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				[
					[
						[104.570251, 24.443079],
						[104.57353, 24.448503],
						[104.5713, 24.455203],
						[104.566474, 24.463126],
						[104.567524, 24.471279],
						[104.56435, 24.471722],
						[104.559681, 24.466848],
						[104.556849, 24.458482],
						[104.55315, 24.453768],
						[104.547459, 24.452208],
						[104.537781, 24.452456],
						[104.530069, 24.455062],
						[104.524955, 24.454282],
						[104.524693, 24.446447],
						[104.528706, 24.438594],
						[104.52784, 24.435066],
						[104.513834, 24.437513],
						[104.505572, 24.441909],
						[104.483645, 24.440012],
						[104.471659, 24.435811],
						[104.467803, 24.440101],
						[104.45983, 24.439409],
						[104.455423, 24.436077],
						[104.435201, 24.427603],
						[104.419097, 24.422301],
						[104.420723, 24.416468],
						[104.417156, 24.410245],
						[104.412881, 24.409092],
						[104.415897, 24.402531],
						[104.421615, 24.395757],
						[104.421379, 24.388185],
						[104.415976, 24.383716],
						[104.400554, 24.383397],
						[104.392292, 24.379974],
						[104.369998, 24.378821],
						[104.36428, 24.380098],
						[104.356857, 24.379264],
						[104.348307, 24.374245],
						[104.347782, 24.365625],
						[104.344635, 24.364028],
						[104.32798, 24.361368],
						[104.320452, 24.355496],
						[104.311744, 24.357182],
						[104.306263, 24.355266],
						[104.300099, 24.348347],
						[104.288375, 24.351931],
						[104.283182, 24.358689],
						[104.270277, 24.366725],
						[104.261438, 24.365359],
						[104.255773, 24.357731],
						[104.249688, 24.358423],
						[104.246305, 24.354858],
						[104.23883, 24.360534],
						[104.226371, 24.36119],
						[104.225427, 24.364685],
						[104.219499, 24.362822],
						[104.215958, 24.358352],
						[104.211604, 24.360073],
						[104.208536, 24.365217],
						[104.209244, 24.375735],
						[104.219106, 24.382155],
						[104.227866, 24.393683],
						[104.226135, 24.401255],
						[104.218948, 24.408277],
						[104.215198, 24.414536],
						[104.207198, 24.418951],
						[104.196812, 24.437725],
						[104.176773, 24.45515],
						[104.16337, 24.452226],
						[104.147738, 24.446943],
						[104.143463, 24.44666],
						[104.141706, 24.452669],
						[104.134965, 24.455576],
						[104.125339, 24.44868],
						[104.112907, 24.446128],
						[104.093026, 24.436059],
						[104.078391, 24.432088],
						[104.058877, 24.422036],
						[104.049146, 24.420919],
						[104.046287, 24.422461],
						[104.040753, 24.431521],
						[104.035717, 24.434339],
						[104.031809, 24.440721],
						[104.017174, 24.447138],
						[104.010354, 24.449017],
						[104.000518, 24.447741],
						[103.996951, 24.445206],
						[103.988952, 24.435066],
						[103.984414, 24.435013],
						[103.968284, 24.44065],
						[103.962251, 24.439445],
						[103.952311, 24.432425],
						[103.945937, 24.429925],
						[103.938226, 24.42216],
						[103.935289, 24.41661],
						[103.928994, 24.411326],
						[103.926948, 24.406574],
						[103.912103, 24.390845],
						[103.912155, 24.386695],
						[103.906411, 24.379584],
						[103.898962, 24.379619],
						[103.887789, 24.37233],
						[103.883855, 24.36433],
						[103.875671, 24.362113],
						[103.867436, 24.361616],
						[103.863685, 24.359558],
						[103.858203, 24.34668],
						[103.851358, 24.340914],
						[103.849312, 24.333622],
						[103.843961, 24.322675],
						[103.839712, 24.317245],
						[103.840289, 24.312774],
						[103.832185, 24.306243],
						[103.818677, 24.301292],
						[103.81692, 24.296429],
						[103.818992, 24.288106],
						[103.815687, 24.28303],
						[103.81873, 24.271244],
						[103.817785, 24.268137],
						[103.809969, 24.262315],
						[103.810153, 24.256936],
						[103.799163, 24.251769],
						[103.78736, 24.248272],
						[103.786102, 24.242324],
						[103.788278, 24.238241],
						[103.787859, 24.232275],
						[103.784895, 24.225953],
						[103.785472, 24.21917],
						[103.779177, 24.2072],
						[103.773512, 24.203879],
						[103.759611, 24.205247],
						[103.742956, 24.20221],
						[103.728583, 24.198285],
						[103.709305, 24.199581],
						[103.700387, 24.205726],
						[103.697581, 24.205797],
						[103.695587, 24.194004],
						[103.691102, 24.184732],
						[103.684624, 24.183844],
						[103.677096, 24.186739],
						[103.671011, 24.186846],
						[103.655432, 24.179208],
						[103.642999, 24.174643],
						[103.638383, 24.171374],
						[103.628915, 24.159116],
						[103.625872, 24.150534],
						[103.628994, 24.141686],
						[103.624928, 24.137421],
						[103.614201, 24.131912],
						[103.604654, 24.1285],
						[103.590569, 24.115812],
						[103.589939, 24.110817],
						[103.58451, 24.106534],
						[103.574963, 24.086217],
						[103.575619, 24.076777],
						[103.578583, 24.074626],
						[103.581494, 24.06643],
						[103.583173, 24.056651],
						[103.581468, 24.048525],
						[103.583802, 24.047618],
						[103.592484, 24.036575],
						[103.607067, 24.025229],
						[103.614096, 24.017937],
						[103.614384, 24.013188],
						[103.621859, 24.010004],
						[103.625794, 24.001057],
						[103.635341, 23.994351],
						[103.640927, 23.984104],
						[103.63639, 23.974727],
						[103.630226, 23.969105],
						[103.63458, 23.970297],
						[103.647485, 23.966134],
						[103.654304, 23.962166],
						[103.668625, 23.949994],
						[103.678854, 23.939334],
						[103.688952, 23.9443],
						[103.695273, 23.942698],
						[103.70183, 23.934387],
						[103.701226, 23.929208],
						[103.688348, 23.920095],
						[103.692702, 23.91342],
						[103.704374, 23.905641],
						[103.70558, 23.901742],
						[103.701908, 23.893909],
						[103.706682, 23.890063],
						[103.714446, 23.889921],
						[103.727848, 23.886075],
						[103.734327, 23.881784],
						[103.753185, 23.866329],
						[103.759926, 23.863515],
						[103.770338, 23.86567],
						[103.772673, 23.868199],
						[103.778758, 23.881927],
						[103.789616, 23.891648],
						[103.796698, 23.896294],
						[103.81254, 23.9016],
						[103.818546, 23.901795],
						[103.825103, 23.896544],
						[103.827254, 23.88823],
						[103.830559, 23.883422],
						[103.834362, 23.882461],
						[103.841129, 23.884847],
						[103.84766, 23.880645],
						[103.851935, 23.881731],
						[103.858833, 23.879808],
						[103.867383, 23.880057],
						[103.87116, 23.874787],
						[103.872314, 23.867273],
						[103.857548, 23.844834],
						[103.86017, 23.839135],
						[103.864472, 23.836926],
						[103.879527, 23.834433],
						[103.89849, 23.834789],
						[103.907382, 23.839313],
						[103.913493, 23.845386],
						[103.921414, 23.848984],
						[103.935367, 23.85178],
						[103.948193, 23.850213],
						[103.95273, 23.848236],
						[103.960258, 23.837389],
						[103.963956, 23.828519],
						[103.969412, 23.809352],
						[103.971982, 23.79542],
						[103.975549, 23.792284],
						[103.994407, 23.789469],
						[104.010328, 23.784765],
						[104.024754, 23.789879],
						[104.043271, 23.790948],
						[104.049618, 23.786725],
						[104.060739, 23.781897],
						[104.064594, 23.777834],
						[104.069132, 23.764843],
						[104.071991, 23.760085],
						[104.079335, 23.755861],
						[104.089485, 23.752136],
						[104.095964, 23.753651],
						[104.106035, 23.746665],
						[104.112251, 23.746023],
						[104.124448, 23.749605],
						[104.127516, 23.752136],
						[104.126388, 23.758018],
						[104.115923, 23.767035],
						[104.116238, 23.772007],
						[104.121431, 23.775678],
						[104.121143, 23.783999],
						[104.127543, 23.785193],
						[104.129011, 23.790627],
						[104.141601, 23.802137],
						[104.147109, 23.805736],
						[104.156368, 23.808657],
						[104.15482, 23.817101],
						[104.158308, 23.818847],
						[104.172341, 23.821091],
						[104.173573, 23.824209],
						[104.169534, 23.829748],
						[104.168826, 23.84072],
						[104.166413, 23.846384],
						[104.159226, 23.850515],
						[104.158335, 23.855822],
						[104.153037, 23.857657],
						[104.153535, 23.860666],
						[104.16038, 23.865154],
						[104.187265, 23.865848],
						[104.192982, 23.86989],
						[104.194005, 23.873291],
						[104.201559, 23.876087],
						[104.212785, 23.873861],
						[104.237308, 23.887784],
						[104.245885, 23.889921],
						[104.259943, 23.890063],
						[104.264822, 23.885968],
						[104.27909, 23.887393],
						[104.296479, 23.882425],
						[104.312348, 23.879042],
						[104.328216, 23.87427],
						[104.340019, 23.873808],
						[104.347494, 23.875553],
						[104.365565, 23.886182],
						[104.371965, 23.892271],
						[104.375112, 23.898057],
						[104.387754, 23.904697],
						[104.396462, 23.906673],
						[104.400895, 23.910643],
						[104.411648, 23.92458],
						[104.416291, 23.929243],
						[104.429116, 23.938836],
						[104.437037, 23.955689],
						[104.444171, 23.961756],
						[104.455292, 23.967183],
						[104.458151, 23.974336],
						[104.464735, 23.983125],
						[104.475934, 23.983961],
						[104.483724, 23.982235],
						[104.501454, 23.981293],
						[104.508247, 23.97841],
						[104.514096, 23.972503],
						[104.518503, 23.963856],
						[104.519919, 23.954924],
						[104.523486, 23.950599],
						[104.534974, 23.950065],
						[104.544652, 23.953162],
						[104.543839, 23.957059],
						[104.548928, 23.964461],
						[104.559681, 23.964372],
						[104.567733, 23.961027],
						[104.573189, 23.962717],
						[104.570173, 23.978268],
						[104.571825, 23.983339],
						[104.571274, 23.997054],
						[104.565609, 24.006055],
						[104.556639, 24.013419],
						[104.547826, 24.011356],
						[104.542974, 24.017528],
						[104.549898, 24.023379],
						[104.555458, 24.020996],
						[104.553885, 24.029657],
						[104.547406, 24.030298],
						[104.552232, 24.033339],
						[104.556245, 24.031934],
						[104.554331, 24.036593],
						[104.550344, 24.035082],
						[104.538935, 24.035455],
						[104.53041, 24.052579],
						[104.526293, 24.063319],
						[104.522148, 24.097185],
						[104.521912, 24.118264],
						[104.523565, 24.128341],
						[104.53062, 24.143285],
						[104.535577, 24.149042],
						[104.545387, 24.1656],
						[104.551682, 24.183293],
						[104.545938, 24.191855],
						[104.536207, 24.20173],
						[104.51908, 24.211693],
						[104.514227, 24.219259],
						[104.512654, 24.228315],
						[104.516824, 24.237317],
						[104.531696, 24.252231],
						[104.535, 24.258977],
						[104.534502, 24.298133],
						[104.52645, 24.317795],
						[104.524194, 24.340417],
						[104.514568, 24.369882],
						[104.513991, 24.401521],
						[104.515696, 24.409039],
						[104.519867, 24.418029],
						[104.527315, 24.425493],
						[104.559445, 24.436697],
						[104.560521, 24.43948],
						[104.570251, 24.443079]
					]
				]
			]
		}
	}, {
		"type": "Feature",
		"properties": {
			"adcode": 532627,
			"name": "广南县",
			"center": [105.056684, 24.050272],
			"centroid": [104.998966, 23.962978],
			"childrenNum": 0,
			"level": "district",
			"parent": {
				"adcode": 532600
			},
			"subFeatureIndex": 6,
			"acroutes": [100000, 530000, 532600]
		},
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				[
					[
						[104.570251, 24.443079],
						[104.560521, 24.43948],
						[104.559445, 24.436697],
						[104.527315, 24.425493],
						[104.519867, 24.418029],
						[104.515696, 24.409039],
						[104.513991, 24.401521],
						[104.514568, 24.369882],
						[104.524194, 24.340417],
						[104.52645, 24.317795],
						[104.534502, 24.298133],
						[104.535, 24.258977],
						[104.531696, 24.252231],
						[104.516824, 24.237317],
						[104.512654, 24.228315],
						[104.514227, 24.219259],
						[104.51908, 24.211693],
						[104.536207, 24.20173],
						[104.545938, 24.191855],
						[104.551682, 24.183293],
						[104.545387, 24.1656],
						[104.535577, 24.149042],
						[104.53062, 24.143285],
						[104.523565, 24.128341],
						[104.521912, 24.118264],
						[104.522148, 24.097185],
						[104.526293, 24.063319],
						[104.53041, 24.052579],
						[104.538935, 24.035455],
						[104.550344, 24.035082],
						[104.554331, 24.036593],
						[104.556245, 24.031934],
						[104.552232, 24.033339],
						[104.547406, 24.030298],
						[104.553885, 24.029657],
						[104.555458, 24.020996],
						[104.549898, 24.023379],
						[104.542974, 24.017528],
						[104.547826, 24.011356],
						[104.556639, 24.013419],
						[104.565609, 24.006055],
						[104.571274, 23.997054],
						[104.571825, 23.983339],
						[104.570173, 23.978268],
						[104.573189, 23.962717],
						[104.567733, 23.961027],
						[104.559681, 23.964372],
						[104.548928, 23.964461],
						[104.543839, 23.957059],
						[104.544652, 23.953162],
						[104.554724, 23.949389],
						[104.557793, 23.94462],
						[104.558921, 23.937982],
						[104.55698, 23.934049],
						[104.557688, 23.923281],
						[104.554357, 23.91406],
						[104.550187, 23.909646],
						[104.532561, 23.904181],
						[104.528469, 23.892093],
						[104.531696, 23.880752],
						[104.538069, 23.874787],
						[104.544862, 23.873772],
						[104.556245, 23.878989],
						[104.571379, 23.880342],
						[104.584231, 23.87744],
						[104.589083, 23.872597],
						[104.596847, 23.845137],
						[104.609489, 23.835038],
						[104.621161, 23.837888],
						[104.621685, 23.829517],
						[104.615548, 23.819274],
						[104.618616, 23.813734],
						[104.629318, 23.81564],
						[104.632858, 23.808426],
						[104.631075, 23.803865],
						[104.64335, 23.79526],
						[104.653658, 23.790075],
						[104.656648, 23.781594],
						[104.665591, 23.7853],
						[104.672778, 23.780934],
						[104.681565, 23.784445],
						[104.688122, 23.784284],
						[104.695518, 23.780845],
						[104.696331, 23.776996],
						[104.693944, 23.771152],
						[104.689354, 23.767837],
						[104.688174, 23.763435],
						[104.694495, 23.761332],
						[104.695964, 23.757643],
						[104.693236, 23.752421],
						[104.676765, 23.747823],
						[104.674588, 23.736897],
						[104.671362, 23.727557],
						[104.661395, 23.719339],
						[104.658116, 23.706128],
						[104.659139, 23.691704],
						[104.6631, 23.679596],
						[104.671493, 23.672392],
						[104.685499, 23.673765],
						[104.69001, 23.672927],
						[104.695885, 23.665668],
						[104.693472, 23.660585],
						[104.684659, 23.648742],
						[104.68062, 23.636506],
						[104.682273, 23.62805],
						[104.688358, 23.609781],
						[104.691741, 23.602269],
						[104.698561, 23.597327],
						[104.707295, 23.584604],
						[104.716894, 23.578554],
						[104.723923, 23.576823],
						[104.732474, 23.589814],
						[104.739346, 23.596559],
						[104.751044, 23.599022],
						[104.765049, 23.59829],
						[104.768748, 23.601092],
						[104.770059, 23.610976],
						[104.77596, 23.616793],
						[104.77861, 23.615954],
						[104.785114, 23.608157],
						[104.788629, 23.60127],
						[104.794635, 23.596827],
						[104.804287, 23.592669],
						[104.835709, 23.588066],
						[104.845702, 23.58405],
						[104.856429, 23.573503],
						[104.870907, 23.567524],
						[104.890841, 23.564776],
						[104.901673, 23.560635],
						[104.907601, 23.560046],
						[104.913764, 23.554548],
						[104.915181, 23.541482],
						[104.918118, 23.540732],
						[104.926774, 23.533788],
						[104.933593, 23.526504],
						[104.933409, 23.529342],
						[104.941619, 23.53593],
						[104.9567, 23.533109],
						[104.956962, 23.527218],
						[104.961867, 23.524111],
						[104.971414, 23.538037],
						[104.978889, 23.540661],
						[104.985158, 23.539161],
						[104.999348, 23.528807],
						[105.008947, 23.524147],
						[105.028854, 23.516184],
						[105.042913, 23.512024],
						[105.059542, 23.505185],
						[105.06442, 23.511988],
						[105.063161, 23.533092],
						[105.066623, 23.540893],
						[105.074125, 23.547801],
						[105.077875, 23.548711],
						[105.09335, 23.539768],
						[105.116562, 23.534948],
						[105.12826, 23.530574],
						[105.153177, 23.533288],
						[105.163878, 23.530271],
						[105.174343, 23.52038],
						[105.193254, 23.513452],
						[105.21442, 23.508578],
						[105.227613, 23.501221],
						[105.230105, 23.497221],
						[105.236111, 23.49431],
						[105.244426, 23.496507],
						[105.247966, 23.501864],
						[105.244242, 23.510328],
						[105.230446, 23.536109],
						[105.225751, 23.550532],
						[105.227089, 23.562473],
						[105.230472, 23.570773],
						[105.237606, 23.577501],
						[105.241331, 23.578465],
						[105.261369, 23.574306],
						[105.271703, 23.566846],
						[105.283952, 23.548408],
						[105.293525, 23.542553],
						[105.302285, 23.541964],
						[105.311019, 23.542999],
						[105.33195, 23.549443],
						[105.331635, 23.554727],
						[105.327412, 23.571647],
						[105.329405, 23.591634],
						[105.328278, 23.602412],
						[105.322848, 23.614277],
						[105.33132, 23.616454],
						[105.33709, 23.615829],
						[105.348683, 23.609781],
						[105.356945, 23.607462],
						[105.365496, 23.597434],
						[105.381075, 23.588512],
						[105.391881, 23.584532],
						[105.399488, 23.577929],
						[105.407356, 23.58414],
						[105.420838, 23.578625],
						[105.430935, 23.582284],
						[105.43403, 23.586602],
						[105.43904, 23.587887],
						[105.437335, 23.593116],
						[105.444941, 23.592009],
						[105.449427, 23.595364],
						[105.445964, 23.602983],
						[105.447643, 23.607372],
						[105.451656, 23.608318],
						[105.463328, 23.605731],
						[105.467157, 23.598058],
						[105.477622, 23.597041],
						[105.479615, 23.594793],
						[105.485569, 23.597362],
						[105.484887, 23.602715],
						[105.487379, 23.604928],
						[105.498841, 23.606052],
						[105.510303, 23.611244],
						[105.513817, 23.621253],
						[105.512742, 23.636827],
						[105.521397, 23.642713],
						[105.5268, 23.649884],
						[105.526512, 23.661299],
						[105.532833, 23.66615],
						[105.53737, 23.675548],
						[105.541882, 23.679008],
						[105.536741, 23.683769],
						[105.535508, 23.689386],
						[105.543796, 23.696322],
						[105.55615, 23.698586],
						[105.588332, 23.70192],
						[105.595361, 23.705985],
						[105.60559, 23.706057],
						[105.609944, 23.712511],
						[105.607846, 23.719214],
						[105.601761, 23.718305],
						[105.595178, 23.720943],
						[105.592292, 23.724277],
						[105.583113, 23.724615],
						[105.579467, 23.729517],
						[105.582798, 23.73843],
						[105.580988, 23.741852],
						[105.582667, 23.74793],
						[105.576372, 23.747734],
						[105.573723, 23.75071],
						[105.570182, 23.749392],
						[105.567821, 23.743759],
						[105.555127, 23.754222],
						[105.547547, 23.753669],
						[105.542773, 23.760085],
						[105.53522, 23.764665],
						[105.535062, 23.768675],
						[105.544688, 23.776979],
						[105.550012, 23.778689],
						[105.548544, 23.783607],
						[105.535193, 23.788115],
						[105.5332, 23.792872],
						[105.535875, 23.799144],
						[105.534511, 23.803598],
						[105.530656, 23.804774],
						[105.532334, 23.811882],
						[105.529607, 23.816211],
						[105.530446, 23.820806],
						[105.523102, 23.826631],
						[105.513214, 23.825883],
						[105.501805, 23.821679],
						[105.496375, 23.820949],
						[105.492336, 23.828216],
						[105.48709, 23.832901],
						[105.485176, 23.838992],
						[105.48633, 23.846348],
						[105.484415, 23.848521],
						[105.477412, 23.847897],
						[105.475157, 23.8508],
						[105.469753, 23.851566],
						[105.465714, 23.858173],
						[105.466527, 23.862661],
						[105.471432, 23.869125],
						[105.476337, 23.872152],
						[105.491969, 23.87728],
						[105.501936, 23.878473],
						[105.509385, 23.884188],
						[105.525384, 23.881909],
						[105.535954, 23.884544],
						[105.53577, 23.889422],
						[105.551665, 23.903131],
						[105.563022, 23.906869],
						[105.565933, 23.91552],
						[105.560425, 23.917247],
						[105.557225, 23.923067],
						[105.550589, 23.928976],
						[105.544216, 23.937608],
						[105.544636, 23.941844],
						[105.536636, 23.945403],
						[105.526407, 23.945332],
						[105.517699, 23.943445],
						[105.509883, 23.951258],
						[105.507286, 23.965137],
						[105.511902, 23.97019],
						[105.513817, 23.984032],
						[105.513555, 23.994386],
						[105.511876, 24.001395],
						[105.505345, 24.010253],
						[105.494775, 24.017919],
						[105.481871, 24.0192],
						[105.476783, 24.023041],
						[105.472481, 24.023006],
						[105.461019, 24.029622],
						[105.449977, 24.029462],
						[105.444837, 24.032556],
						[105.427788, 24.034228],
						[105.412995, 24.038994],
						[105.406228, 24.044009],
						[105.40295, 24.049041],
						[105.39676, 24.064599],
						[105.388419, 24.064546],
						[105.381574, 24.068173],
						[105.376669, 24.077026],
						[105.364578, 24.077684],
						[105.359437, 24.084066],
						[105.349654, 24.084493],
						[105.345956, 24.086181],
						[105.346087, 24.090892],
						[105.33932, 24.095727],
						[105.332763, 24.094963],
						[105.328933, 24.106232],
						[105.320252, 24.116345],
						[105.315793, 24.116789],
						[105.305984, 24.112293],
						[105.299374, 24.111439],
						[105.293551, 24.113163],
						[105.287335, 24.101664],
						[105.283873, 24.099016],
						[105.274798, 24.10154],
						[105.272778, 24.10042],
						[105.273146, 24.09283],
						[105.281381, 24.08819],
						[105.28647, 24.081879],
						[105.293053, 24.079231],
						[105.293053, 24.074822],
						[105.288515, 24.072937],
						[105.284502, 24.065097],
						[105.274929, 24.063265],
						[105.265434, 24.064599],
						[105.260215, 24.061292],
						[105.255677, 24.063657],
						[105.251848, 24.069595],
						[105.245737, 24.072617],
						[105.234905, 24.075017],
						[105.230236, 24.079568],
						[105.228059, 24.085488],
						[105.216125, 24.092456],
						[105.205581, 24.102179],
						[105.20065, 24.105343],
						[105.195037, 24.121747],
						[105.181871, 24.132872],
						[105.183523, 24.13703],
						[105.181084, 24.141064],
						[105.184389, 24.145506],
						[105.177753, 24.154301],
						[105.181372, 24.15908],
						[105.182815, 24.167057],
						[105.188533, 24.163664],
						[105.18987, 24.167679],
						[105.19947, 24.164694],
						[105.202932, 24.168567],
						[105.208755, 24.166613],
						[105.209358, 24.157232],
						[105.215837, 24.161621],
						[105.222289, 24.161727],
						[105.22958, 24.165742],
						[105.230551, 24.176952],
						[105.236059, 24.179332],
						[105.23716, 24.186011],
						[105.243062, 24.206721],
						[105.239993, 24.210521],
						[105.236111, 24.207946],
						[105.232544, 24.211924],
						[105.234616, 24.217607],
						[105.2316, 24.219507],
						[105.222184, 24.217909],
						[105.215233, 24.214908],
						[105.210434, 24.219969],
						[105.204821, 24.232576],
						[105.20469, 24.237619],
						[105.20128, 24.248219],
						[105.197162, 24.252124],
						[105.191129, 24.253403],
						[105.181923, 24.252053],
						[105.178487, 24.253438],
						[105.181661, 24.261747],
						[105.168363, 24.277669],
						[105.160259, 24.278947],
						[105.160128, 24.282107],
						[105.166449, 24.289011],
						[105.176337, 24.287342],
						[105.177727, 24.290999],
						[105.172927, 24.296429],
						[105.172638, 24.303599],
						[105.180586, 24.313324],
						[105.189503, 24.318221],
						[105.196795, 24.326969],
						[105.196218, 24.337064],
						[105.187903, 24.347105],
						[105.170042, 24.356898],
						[105.157688, 24.367168],
						[105.1446, 24.375593],
						[105.138568, 24.37671],
						[105.116772, 24.371567],
						[105.111736, 24.372471],
						[105.102897, 24.382279],
						[105.103081, 24.391892],
						[105.108772, 24.40567],
						[105.108038, 24.414021],
						[105.099094, 24.416486],
						[105.095606, 24.41927],
						[105.085691, 24.419997],
						[105.075043, 24.427567],
						[105.066886, 24.428134],
						[105.055083, 24.431964],
						[105.054611, 24.439321],
						[105.042834, 24.441873],
						[105.019412, 24.438683],
						[105.003308, 24.431893],
						[104.997564, 24.423808],
						[104.986784, 24.415458],
						[104.979991, 24.412887],
						[104.959087, 24.411326],
						[104.943507, 24.408206],
						[104.935193, 24.408365],
						[104.929869, 24.410848],
						[104.922262, 24.419482],
						[104.913895, 24.426291],
						[104.896532, 24.430067],
						[104.888979, 24.433222],
						[104.873635, 24.43496],
						[104.854724, 24.442405],
						[104.836653, 24.44666],
						[104.822857, 24.443823],
						[104.80809, 24.4426],
						[104.79377, 24.442512],
						[104.784983, 24.443823],
						[104.774623, 24.450896],
						[104.771921, 24.456639],
						[104.765286, 24.459475],
						[104.754375, 24.456958],
						[104.75267, 24.45297],
						[104.752853, 24.435953],
						[104.744932, 24.436928],
						[104.728644, 24.445915],
						[104.715425, 24.441466],
						[104.71039, 24.430368],
						[104.707399, 24.427957],
						[104.70336, 24.419802],
						[104.704331, 24.409465],
						[104.710337, 24.386607],
						[104.71553, 24.372241],
						[104.719176, 24.357146],
						[104.721117, 24.339991],
						[104.717209, 24.328956],
						[104.708973, 24.321309],
						[104.701944, 24.321007],
						[104.695125, 24.322781],
						[104.690036, 24.327537],
						[104.683715, 24.330677],
						[104.660818, 24.355638],
						[104.641645, 24.367824],
						[104.62798, 24.370857],
						[104.610984, 24.377118],
						[104.620111, 24.393097],
						[104.629816, 24.39785],
						[104.625436, 24.405049],
						[104.62339, 24.414341],
						[104.617436, 24.417036],
						[104.616335, 24.42177],
						[104.604742, 24.420298],
						[104.597345, 24.422567],
						[104.590998, 24.42239],
						[104.583602, 24.41817],
						[104.578933, 24.418897],
						[104.576415, 24.42356],
						[104.573766, 24.436591],
						[104.570251, 24.443079]
					]
				]
			]
		}
	}, {
		"type": "Feature",
		"properties": {
			"adcode": 532628,
			"name": "富宁县",
			"center": [105.62856, 23.626494],
			"centroid": [105.744163, 23.704748],
			"childrenNum": 0,
			"level": "district",
			"parent": {
				"adcode": 532600
			},
			"subFeatureIndex": 7,
			"acroutes": [100000, 530000, 532600]
		},
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				[
					[
						[105.311124, 23.379578],
						[105.314691, 23.379632],
						[105.325524, 23.390052],
						[105.330455, 23.387407],
						[105.333707, 23.380794],
						[105.349864, 23.368407],
						[105.353614, 23.361525],
						[105.352854, 23.351443],
						[105.354821, 23.342665],
						[105.358126, 23.337462],
						[105.371659, 23.322157],
						[105.375489, 23.315416],
						[105.387344, 23.307977],
						[105.393481, 23.308335],
						[105.404655, 23.290343],
						[105.409822, 23.285926],
						[105.415802, 23.283726],
						[105.427027, 23.288555],
						[105.43209, 23.296961],
						[105.439643, 23.296585],
						[105.445597, 23.292901],
						[105.450764, 23.286641],
						[105.453938, 23.276714],
						[105.453912, 23.271759],
						[105.459918, 23.259434],
						[105.463878, 23.255373],
						[105.475786, 23.249469],
						[105.487274, 23.237321],
						[105.490054, 23.230325],
						[105.497188, 23.220752],
						[105.501962, 23.202731],
						[105.515837, 23.194605],
						[105.524545, 23.192744],
						[105.528925, 23.186479],
						[105.532885, 23.184636],
						[105.542668, 23.184224],
						[105.542013, 23.187947],
						[105.544872, 23.194677],
						[105.550012, 23.197863],
						[105.545842, 23.200708],
						[105.54036, 23.210283],
						[105.532098, 23.218765],
						[105.526459, 23.234566],
						[105.527666, 23.244478],
						[105.531836, 23.248181],
						[105.545947, 23.251491],
						[105.560294, 23.257341],
						[105.562995, 23.261259],
						[105.566064, 23.275051],
						[105.56971, 23.28242],
						[105.586155, 23.301843],
						[105.593263, 23.312555],
						[105.607951, 23.315219],
						[105.615714, 23.314272],
						[105.614141, 23.322122],
						[105.618783, 23.326627],
						[105.623216, 23.324231],
						[105.631792, 23.332599],
						[105.638454, 23.336372],
						[105.642808, 23.335835],
						[105.648841, 23.340037],
						[105.649261, 23.345919],
						[105.66046, 23.348154],
						[105.666991, 23.346777],
						[105.674046, 23.340663],
						[105.674833, 23.337373],
						[105.671004, 23.329756],
						[105.67166, 23.326467],
						[105.681023, 23.321514],
						[105.685193, 23.326824],
						[105.693403, 23.32475],
						[105.700616, 23.328398],
						[105.697258, 23.336122],
						[105.693508, 23.338231],
						[105.682387, 23.348904],
						[105.674151, 23.348404],
						[105.670217, 23.354822],
						[105.673155, 23.357718],
						[105.682964, 23.355501],
						[105.686688, 23.356824],
						[105.694268, 23.363331],
						[105.694242, 23.366763],
						[105.688603, 23.371464],
						[105.675043, 23.374645],
						[105.674046, 23.382956],
						[105.668879, 23.387925],
						[105.664106, 23.387299],
						[105.661221, 23.390498],
						[105.647503, 23.398094],
						[105.636802, 23.39779],
						[105.630848, 23.400542],
						[105.637904, 23.404295],
						[105.648421, 23.404366],
						[105.665076, 23.400631],
						[105.671869, 23.408619],
						[105.680131, 23.406654],
						[105.690649, 23.400882],
						[105.699881, 23.401436],
						[105.715225, 23.414891],
						[105.738017, 23.430704],
						[105.754017, 23.451963],
						[105.758685, 23.459573],
						[105.77159, 23.464717],
						[105.778802, 23.465914],
						[105.806159, 23.46745],
						[105.811588, 23.473915],
						[105.81324, 23.48356],
						[105.813791, 23.502167],
						[105.815758, 23.507221],
						[105.826145, 23.515541],
						[105.844452, 23.524129],
						[105.852399, 23.526932],
						[105.880778, 23.529164],
						[105.89203, 23.524861],
						[105.898824, 23.516202],
						[105.902155, 23.505649],
						[105.908948, 23.499507],
						[105.912934, 23.49931],
						[105.925603, 23.508578],
						[105.935832, 23.508899],
						[105.948631, 23.49981],
						[105.959936, 23.494185],
						[105.971948, 23.493132],
						[105.986216, 23.489596],
						[105.996787, 23.480506],
						[105.997364, 23.474094],
						[105.990675, 23.465538],
						[105.986977, 23.457233],
						[105.991803, 23.448337],
						[105.999829, 23.447944],
						[106.010504, 23.455857],
						[106.022359, 23.472719],
						[106.03605, 23.482702],
						[106.044758, 23.485756],
						[106.062987, 23.488435],
						[106.06797, 23.490542],
						[106.072167, 23.495614],
						[106.073872, 23.502525],
						[106.086199, 23.524183],
						[106.092914, 23.527432],
						[106.100126, 23.528164],
						[106.107339, 23.533716],
						[106.11665, 23.553727],
						[106.120584, 23.559261],
						[106.133279, 23.563901],
						[106.141462, 23.569666],
						[106.135403, 23.579982],
						[106.124886, 23.585888],
						[106.122132, 23.589779],
						[106.119798, 23.600324],
						[106.120768, 23.605374],
						[106.137266, 23.632064],
						[106.144138, 23.648849],
						[106.149514, 23.665383],
						[106.149882, 23.683287],
						[106.153003, 23.699817],
						[106.15817, 23.70948],
						[106.15733, 23.724152],
						[106.15455, 23.729874],
						[106.144977, 23.744294],
						[106.141856, 23.761029],
						[106.141803, 23.768372],
						[106.136925, 23.790378],
						[106.136872, 23.79542],
						[106.144531, 23.806466],
						[106.155704, 23.813859],
						[106.169159, 23.816656],
						[106.176634, 23.816211],
						[106.192293, 23.824761],
						[106.19148, 23.835537],
						[106.184451, 23.843089],
						[106.172831, 23.861628],
						[106.181565, 23.863711],
						[106.192057, 23.862376],
						[106.196778, 23.865367],
						[106.197722, 23.871119],
						[106.192424, 23.878882],
						[106.187441, 23.880485],
						[106.169186, 23.883405],
						[106.163442, 23.88636],
						[106.155494, 23.893927],
						[106.158301, 23.89957],
						[106.154498, 23.908524],
						[106.14781, 23.914399],
						[106.143324, 23.920415],
						[106.139102, 23.92102],
						[106.136138, 23.935579],
						[106.130289, 23.952753],
						[106.127745, 23.956863],
						[106.119719, 23.960956],
						[106.108126, 23.973731],
						[106.103562, 23.981666],
						[106.096218, 23.989619],
						[106.087012, 23.989458],
						[106.081766, 23.993657],
						[106.085465, 23.999314],
						[106.090238, 23.998993],
						[106.096533, 24.017937],
						[106.095694, 24.022579],
						[106.088612, 24.030796],
						[106.083288, 24.031382],
						[106.075524, 24.02843],
						[106.069649, 24.03718],
						[106.05782, 24.044827],
						[106.054332, 24.049877],
						[106.054253, 24.06083],
						[106.052522, 24.084191],
						[106.049978, 24.089826],
						[106.035368, 24.095265],
						[106.031592, 24.099798],
						[106.02708, 24.099886],
						[106.024248, 24.103317],
						[106.02013, 24.100829],
						[106.011815, 24.099495],
						[106.007409, 24.104614],
						[106.004445, 24.112133],
						[105.998596, 24.116594],
						[105.997993, 24.120663],
						[106.007698, 24.124875],
						[105.998308, 24.124218],
						[105.986977, 24.119153],
						[105.977115, 24.117269],
						[105.975069, 24.114958],
						[105.963844, 24.111066],
						[105.953824, 24.112844],
						[105.933261, 24.123809],
						[105.924475, 24.123791],
						[105.919465, 24.122192],
						[105.91018, 24.11487],
						[105.903413, 24.105237],
						[105.902181, 24.099282],
						[105.904909, 24.082804],
						[105.905013, 24.074377],
						[105.907872, 24.069488],
						[105.905564, 24.065861],
						[105.905905, 24.058074],
						[105.90163, 24.046925],
						[105.898771, 24.043404],
						[105.892293, 24.040292],
						[105.885027, 24.045093],
						[105.880516, 24.044684],
						[105.876057, 24.049254],
						[105.864333, 24.051192],
						[105.859245, 24.05674],
						[105.849881, 24.055976],
						[105.850721, 24.048063],
						[105.845764, 24.03967],
						[105.845501, 24.035579],
						[105.841488, 24.030813],
						[105.831784, 24.027559],
						[105.825148, 24.03092],
						[105.815548, 24.028306],
						[105.807208, 24.028181],
						[105.79648, 24.023682],
						[105.788009, 24.031969],
						[105.789425, 24.039492],
						[105.80191, 24.052206],
						[105.804401, 24.057238],
						[105.801149, 24.063425],
						[105.790395, 24.069844],
						[105.778147, 24.072599],
						[105.765374, 24.073737],
						[105.761623, 24.070982],
						[105.739329, 24.059496],
						[105.733322, 24.059496],
						[105.724038, 24.062679],
						[105.708983, 24.066075],
						[105.700196, 24.065595],
						[105.695213, 24.061683],
						[105.690203, 24.051121],
						[105.675332, 24.038105],
						[105.658152, 24.036291],
						[105.656159, 24.032681],
						[105.649418, 24.03309],
						[105.641654, 24.044649],
						[105.640369, 24.053113],
						[105.643412, 24.06371],
						[105.638218, 24.076137],
						[105.634153, 24.093079],
						[105.634337, 24.101664],
						[105.628225, 24.103459],
						[105.630245, 24.11048],
						[105.627779, 24.121801],
						[105.628435, 24.126563],
						[105.620068, 24.131042],
						[105.616947, 24.135537],
						[105.613092, 24.134365],
						[105.600686, 24.137652],
						[105.59523, 24.137794],
						[105.587099, 24.1293],
						[105.568608, 24.13145],
						[105.55796, 24.129087],
						[105.551245, 24.124769],
						[105.545658, 24.123631],
						[105.539967, 24.12811],
						[105.533829, 24.129798],
						[105.529397, 24.128696],
						[105.527377, 24.124733],
						[105.531311, 24.116487],
						[105.530787, 24.113608],
						[105.522473, 24.10689],
						[105.517856, 24.097131],
						[105.518092, 24.075888],
						[105.515784, 24.070182],
						[105.509201, 24.061221],
						[105.509201, 24.051993],
						[105.504768, 24.044382],
						[105.51025, 24.034281],
						[105.509253, 24.024856],
						[105.5001, 24.02466],
						[105.494775, 24.017919],
						[105.505345, 24.010253],
						[105.511876, 24.001395],
						[105.513555, 23.994386],
						[105.513817, 23.984032],
						[105.511902, 23.97019],
						[105.507286, 23.965137],
						[105.509883, 23.951258],
						[105.517699, 23.943445],
						[105.526407, 23.945332],
						[105.536636, 23.945403],
						[105.544636, 23.941844],
						[105.544216, 23.937608],
						[105.550589, 23.928976],
						[105.557225, 23.923067],
						[105.560425, 23.917247],
						[105.565933, 23.91552],
						[105.563022, 23.906869],
						[105.551665, 23.903131],
						[105.53577, 23.889422],
						[105.535954, 23.884544],
						[105.525384, 23.881909],
						[105.509385, 23.884188],
						[105.501936, 23.878473],
						[105.491969, 23.87728],
						[105.476337, 23.872152],
						[105.471432, 23.869125],
						[105.466527, 23.862661],
						[105.465714, 23.858173],
						[105.469753, 23.851566],
						[105.475157, 23.8508],
						[105.477412, 23.847897],
						[105.484415, 23.848521],
						[105.48633, 23.846348],
						[105.485176, 23.838992],
						[105.48709, 23.832901],
						[105.492336, 23.828216],
						[105.496375, 23.820949],
						[105.501805, 23.821679],
						[105.513214, 23.825883],
						[105.523102, 23.826631],
						[105.530446, 23.820806],
						[105.529607, 23.816211],
						[105.532334, 23.811882],
						[105.530656, 23.804774],
						[105.534511, 23.803598],
						[105.535875, 23.799144],
						[105.5332, 23.792872],
						[105.535193, 23.788115],
						[105.548544, 23.783607],
						[105.550012, 23.778689],
						[105.544688, 23.776979],
						[105.535062, 23.768675],
						[105.53522, 23.764665],
						[105.542773, 23.760085],
						[105.547547, 23.753669],
						[105.555127, 23.754222],
						[105.567821, 23.743759],
						[105.570182, 23.749392],
						[105.573723, 23.75071],
						[105.576372, 23.747734],
						[105.582667, 23.74793],
						[105.580988, 23.741852],
						[105.582798, 23.73843],
						[105.579467, 23.729517],
						[105.583113, 23.724615],
						[105.592292, 23.724277],
						[105.595178, 23.720943],
						[105.601761, 23.718305],
						[105.607846, 23.719214],
						[105.609944, 23.712511],
						[105.60559, 23.706057],
						[105.595361, 23.705985],
						[105.588332, 23.70192],
						[105.55615, 23.698586],
						[105.543796, 23.696322],
						[105.535508, 23.689386],
						[105.536741, 23.683769],
						[105.541882, 23.679008],
						[105.53737, 23.675548],
						[105.532833, 23.66615],
						[105.526512, 23.661299],
						[105.5268, 23.649884],
						[105.521397, 23.642713],
						[105.512742, 23.636827],
						[105.513817, 23.621253],
						[105.510303, 23.611244],
						[105.498841, 23.606052],
						[105.487379, 23.604928],
						[105.484887, 23.602715],
						[105.485569, 23.597362],
						[105.479615, 23.594793],
						[105.477622, 23.597041],
						[105.467157, 23.598058],
						[105.463328, 23.605731],
						[105.451656, 23.608318],
						[105.447643, 23.607372],
						[105.445964, 23.602983],
						[105.449427, 23.595364],
						[105.444941, 23.592009],
						[105.437335, 23.593116],
						[105.43904, 23.587887],
						[105.43403, 23.586602],
						[105.430935, 23.582284],
						[105.420838, 23.578625],
						[105.407356, 23.58414],
						[105.399488, 23.577929],
						[105.391881, 23.584532],
						[105.381075, 23.588512],
						[105.365496, 23.597434],
						[105.356945, 23.607462],
						[105.348683, 23.609781],
						[105.33709, 23.615829],
						[105.33132, 23.616454],
						[105.322848, 23.614277],
						[105.328278, 23.602412],
						[105.329405, 23.591634],
						[105.327412, 23.571647],
						[105.331635, 23.554727],
						[105.33195, 23.549443],
						[105.311019, 23.542999],
						[105.302285, 23.541964],
						[105.293525, 23.542553],
						[105.283952, 23.548408],
						[105.271703, 23.566846],
						[105.261369, 23.574306],
						[105.241331, 23.578465],
						[105.237606, 23.577501],
						[105.230472, 23.570773],
						[105.227089, 23.562473],
						[105.225751, 23.550532],
						[105.230446, 23.536109],
						[105.244242, 23.510328],
						[105.247966, 23.501864],
						[105.244426, 23.496507],
						[105.236111, 23.49431],
						[105.2364, 23.486738],
						[105.239809, 23.483292],
						[105.250406, 23.47972],
						[105.254287, 23.473987],
						[105.244347, 23.470379],
						[105.239836, 23.466557],
						[105.237055, 23.455536],
						[105.240308, 23.447265],
						[105.252714, 23.438118],
						[105.258982, 23.435796],
						[105.281722, 23.433759],
						[105.284843, 23.437707],
						[105.29182, 23.428756],
						[105.278995, 23.42697],
						[105.274352, 23.42429],
						[105.274562, 23.415999],
						[105.268949, 23.409084],
						[105.27068, 23.396753],
						[105.276136, 23.386299],
						[105.290115, 23.381562],
						[105.311124, 23.379578]
					]
				]
			]
		}
	}]
}
export default wenJson
